/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class SubnetFilters {
  /**
  * Matches if any value in this list is in the `subnets` list.
  */
  'containsAnyOf'?: Array<string>;
  /**
  * Matches if none of the values in this list are in the `subnets` list.
  */
  'containsNoneOf'?: Array<string>;
  /**
  * Matches if all values in this list are in the `subnets` list.
  */
  'containsAllOf'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "containsAnyOf",
      "baseName": "containsAnyOf",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "containsNoneOf",
      "baseName": "containsNoneOf",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "containsAllOf",
      "baseName": "containsAllOf",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SubnetFilters.attributeTypeMap;
  }

  public constructor() {
  }
}

